<template>
  <div ref="target" class="wrap tw-relative tw-w-fit">
    <cl-button
      :variant="'secondary'"
      :data-test-id="testId"
      :disabled="disabled"
      :readonly="readonly"
      @click="isOpen = !isOpen"
    >
      <span class="tw-sr-only">Dropdown</span>
      <div class="tw-flex tw-items-center">
        <template v-if="title">
          {{ title }}
        </template>
        <template v-else>
          <slot name="title"></slot>
        </template>
        <ClIconTablerChevronDown
          class="tw-transition-transform"
          :class="isOpen ? 'tw-rotate-180' : 'tw-rotate-0'"
        />
      </div>
    </cl-button>
    <!-- Dropdown menu -->
    <div
      v-if="isOpen"
      class="tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-shadow-md tw-transition-opacity"
      :class="classes"
      @click="isOpen = false"
    >
      <ul
        class="tw-mb-0 tw-w-full tw-py-1 tw-text-base tw-font-normal tw-text-dorian-gray-500"
      >
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { onClickOutside } from "@vueuse/core";

import { ClIconTablerChevronDown } from "../icons";
import { ClButton } from "../button";

import type { Position } from "./types";

export interface DropdownProps {
  title?: string;
  position?: Position;
  testId?: string;
  disabled?: boolean;
  readonly?: boolean;
}

const props = withDefaults(defineProps<DropdownProps>(), {
  position: "bottom",
  testId: "cl-dropdown-toggle-btn",
  disabled: false,
  readonly: false,
});

const positions = {
  top: "tw-bottom-12",
  bottom: "tw-top-12",
};

const isOpen = ref(false);

const target = ref(null);
onClickOutside(target, () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
});

const classes = computed(() => {
  return [
    positions[props.position],
    isOpen.value ? "tw-opacity-100" : "tw-opacity-0",
  ];
});
</script>

<style scoped></style>
